<template>
  <div class="chart-title">
    <el-tooltip
      effect="light"
      :content="tooltipText"
      placement="bottom"
      :disabled="tooltipText ? false : true"
    >
      <div class="chart-title-left">
        <img
          v-if="showIcon"
          class="charts-icon"
          :src="require('@/assets/images/largescreen/charts-icon.png')"
          alt=""
        />
        <dv-decoration-1 v-if="showIcon" />
        <span class="chart-title-text">{{ leftTitle }}</span>
      </div>
    </el-tooltip>
    <div class="chart-title-right">
      {{ rightTitle }}
      <slot name="detail"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "chart-title",
  props: {
    leftTitle: {
      type: String,
      default: "",
    },
    rightTitle: {
      type: String,
      default: "",
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    tooltipText: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-title {
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.9);
  font-weight: bolder;
  padding: 5px 10px;
  background: linear-gradient(
    95deg,
    rgba(28, 124, 232, 0.4) 20%,
    rgba(28, 124, 232, 0.1) 100%
  );
  // background: rgba(125, 155, 243, 0.2);
  position: relative;
  .chart-title-text {
    font-size: 14px;
  }
  .charts-icon {
    width: 20px;
    height: 25px;
    position: absolute;
    left: 15px;
    top: 0;
  }

  .dv-decoration-1 {
    width: 50px;
    height: 18px;
  }
  .chart-title-left {
    display: flex;
    align-items: center;
  }
  .chart-title-right {
    position: absolute;
    right: 10px;
  }
}
</style>
